"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useFlash = void 0;

var _reactHotToast = _interopRequireDefault(require("react-hot-toast"));

/** @deprecated addMessage is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use the `toast()` API: https://react-hot-toast.com/docs/toast */
const addMessage = text => {
  console.warn('addMessage is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use the `toast()` API: https://react-hot-toast.com/docs/toast');
  (0, _reactHotToast.default)(text);
};
/** @deprecated dismissMessage is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use the `toast()` API: https://react-hot-toast.com/docs/toast */


const dismissMessage = () => {
  console.warn('dismissMessage is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use the react-hot-toast API: https://react-hot-toast.com/docs');
};
/** @deprecated cycleMessage is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use the `toast()` API: https://react-hot-toast.com/docs/toast */


const cycleMessage = () => {
  console.warn('cycleMessage is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use the react-hot-toast API: https://react-hot-toast.com/docs');
};
/** @deprecated useFlash is deprecated and will be removed in RedwoodJS v1.0. Please update your components to use the `toast()` API: https://react-hot-toast.com/docs/toast */


const useFlash = () => {
  return {
    addMessage,
    dismissMessage,
    cycleMessage
  };
};

exports.useFlash = useFlash;